export default {
    install(Vue, options) {
        Vue.prototype.post = function (url, params, opts) {
            if (opts.isLoading) {
                this.showLoading(opts.loadingDom)
            }
            let that = this;
            $.support.cors = true; //添加为了ie9能够发起请求
            $.ajax({
                type: 'post',
                url: ajaxUrl + url,
                data: params,
                dataType: 'json',
                success: function (res) {
                    if (opts.isLoading) {
                        that.hideLoading(opts.loadingDom)
                    }
                    if (res.code == 200) {
                        opts.success(res.data)
                    } else {
                        console.log(res.message)
                    }
                },
                error: function (err) {
                	console.log(err);
                    if (opts.isLoading) {
                        that.hideLoading()
                    }
                }
            })
        },
        Vue.prototype.get = function (url, params, opts) {
                if (opts.isLoading) {
                    this.showLoading(opts.loadingDom)
                }
                $.support.cors = true;
                let that = this;
                $.ajax({
                    type: 'get',
                    url: ajaxUrl1 + url,
                    data: params,
                    dataType: 'json',
                    success: function (res) {
                        if (opts.isLoading) {
                            that.hideLoading(opts.loadingDom)
                        }
                        if (res.code == 100) {
                            opts.success(res.data)
                        } else {
                            console.log(res.message)
                        }
                    },
                    error: function (err) {
                        if (opts.isLoading) {
                            that.hideLoading()
                        }
                    }
                })
            },
        Vue.prototype.getAjax = function (url, params, opts) {
                if (opts.isLoading) {
                    this.showLoading(opts.loadingDom)
                }
                let that = this;
                $.support.cors = true;
                $.ajax({
                    type: 'get',
                    url: ajaxUrl1 + url,
                    data: params,
                    dataType: 'json',
                    success: function (res) {
                        if (opts.isLoading) {
                            that.hideLoading(opts.loadingDom)
                        }
                        if (typeof res=='string') {
                        	res=JSON.parse(res);
                        }
                        if (res.code == 100) {
                            opts.success(res)
                        } else {
                            console.log(res.message)
                        }
                    },
                    error: function (err) {
                    	console.log(err);
                        if (opts.isLoading) {
                            that.hideLoading()
                        }
                    }
                })
            },
        Vue.prototype.getAjaxCom= function (url,method,params, opts) {
                if (opts.isLoading) {
                    this.showLoading(opts.loadingDom)
                }
                let that = this;
                $.support.cors = true;
                $.ajax({
                    type: method,
                    url: ajaxUrl2 + url,
                    data: params,
                    dataType: 'json',
                    success: function (res) {
                        if (opts.isLoading) {
                            that.hideLoading(opts.loadingDom)
                        }
                        if (typeof res=='string') {
                        	res=JSON.parse(res);
                        }
                        if (res.code == 200) {
                            opts.success(res)
                        } else if(res.code == 6002){
                        	opts.success([]);
                        } else {
                            that.$message({
								showClose: true,
								message: res.message,
								type: 'warning'
							});
                        }
                    },
                    error: function (err) {
                        if (opts.isLoading) {
                            that.hideLoading()
                        }
                    }
                });
            },
        Vue.prototype.getAjaxCom1= function (url,method,params, opts) {
                if (opts.isLoading) {
                    this.showLoading(opts.loadingDom)
                }
                let that = this;
                $.support.cors = true;
                $.ajax({
                    type: method,
                    url: ajaxUrl3 + url,
                    data: params,
                    dataType: 'json',
                    success: function (res) {
                        if (opts.isLoading) {
                            that.hideLoading(opts.loadingDom)
                        }
                        if (typeof res=='string') {
                        	res=JSON.parse(res);
                        }
                        if (res.code == 200) {
                            opts.success(res)
                        } else if(res.code == 6002){
                        	opts.success([]);
                        } else {
                            that.$message({
								showClose: true,
								message: res.message,
								type: 'warning'
							});
                        }
                    },
                    error: function (err) {
                        if (opts.isLoading) {
                            that.hideLoading()
                        }
                    }
                });
            },
        Vue.prototype.getAjaxCommon= function (url,method,params, opts) {
                if (opts.isLoading) {
                    this.showLoading(opts.loadingDom)
                }
                let that = this;
                $.support.cors = true;
                $.ajax({
                    type: method,
                    url: url,
                    data: params,
                    dataType: 'json',
                    success: function (res) {
                        if (opts.isLoading) {
                            that.hideLoading(opts.loadingDom)
                        }
                        if (typeof res=='string') {
                        	res=JSON.parse(res);
                        }
                        if (res.code == 200||res.status == 'OK'||res.status == 200) {
                        	if (opts.success&& typeof opts.success=='function') {
                               opts.success(res)
                           }
                        } else if(res.code == 1009){
                        	if (opts.getNewAccessToken&& typeof opts.getNewAccessToken=='function') {
                        	opts.getNewAccessToken();
                        	}
                        } else if(res.code == 1015||res.code == 1004){
                        	if (opts.jumpToLogin&& typeof opts.jumpToLogin=='function') {
                        	opts.jumpToLogin();
                        	}
                        } else if(res.code == 1122){
                        	if (opts.failSendSms&& typeof opts.failSendSms=='function') {
                        	opts.failSendSms();
                        	}
                        } else {
                        	if (opts.error&& typeof opts.error=='function') {
                        	opts.error(res);
                        	}
                        }
                    },
                    error: function (err) {
                        if (opts.isLoading) {
                            that.hideLoading();
                            console.log(err);
                        }
                    }
                });
            },
            Vue.prototype.getAjaxCommonForToken= function (url,method,params, opts) {
                if (opts.isLoading) {
                    this.showLoading(opts.loadingDom)
                }
                let that = this;
                $.ajax({
                    type: method,
                    url: url,
                    data: params,
                    dataType: 'json',
                    contentType: "application/json; charset=utf-8",
                    headers:{accessToken:that.cookies().read('access_token')},
                    success: function (res) {
                        if (opts.isLoading) {
                            that.hideLoading(opts.loadingDom)
                        }
                        if (typeof res=='string') {
                        	res=JSON.parse(res);
                        }
                        if (res.code == 200||res.status == 'OK') {
                        	if (opts.success&& typeof opts.success=='function') {
                               opts.success(res)
                           }
                        } else if(res.code == 1009){
                        	if (opts.getNewAccessToken&& typeof opts.getNewAccessToken=='function') {
                        	opts.getNewAccessToken();
                        	}
                        } else if(res.code == 1015||res.code == 1004){
                        	if (opts.jumpToLogin&& typeof opts.jumpToLogin=='function') {
                        	opts.jumpToLogin();
                        	}
                        } else if(res.code == 1122){
                        	if (opts.failSendSms&& typeof opts.failSendSms=='function') {
                        	opts.failSendSms();
                        	}
                        } else {
                        	if (opts.error&& typeof opts.error=='function') {
                        	opts.error(res);
                        	}
                        }
                    },
                    error: function (err) {
                        if (opts.isLoading) {
                            that.hideLoading();
                            console.log(err);
                        }
                    }
                });
            },
            Vue.prototype.getAjaxForDownload= function (url,method,params, opts) {
                if (opts.isLoading) {
                    this.showLoading(opts.loadingDom)
                }
                let that = this;
                $.support.cors = true;
                $.ajax({
                    type: method,
                    url: url,
                    data: params,
                    dataType: 'json',
                    success: function (res) {
                        if (opts.isLoading) {
                            that.hideLoading(opts.loadingDom)
                        }
                        if (typeof res=='string') {
                        	res=JSON.parse(res);
                        }
                        if (res.code == 0) {
                        	if (opts.success&& typeof opts.success=='function') {
                               opts.success(res)
                           }
                        } else {
                        	if (opts.error&& typeof opts.error=='function') {
                        	opts.error(res);
                        	}
                        }
                    },
                    error: function (err) {
                        if (opts.isLoading) {
                            that.hideLoading();
                            console.log(err);
                        }
                    }
                });
            },
            Vue.prototype.refreshToken = function () {
            	$.support.cors = true;
                $.ajax({
                    type: 'POST',
                    url: platformUrl + 'oauth/token',
                    data: {
                        grant_type: 'refresh_token',
                        refresh_token: sessionStorage.getItem('refresh_token'),
                        client_id: 'client_fund_password',
                        client_secret: 123456
                    },
                    dataType: 'json',
                    success: function (res) {
                        if (res.code == 200) {
                            sessionStorage.setItem("access_token", res.access_token);
                            sessionStorage.setItem("refresh_token", res.refresh_token);
                        } else {
                            window.location.href = '/login.html'
                        }
                    }
                });
            },
            Vue.prototype.showLoading = function (dom) {
                var loading = document.createElement('div')
                loading.className = 'loading'
                var html = '<p><span></span><span></span>加载中</p>'
                loading.innerHTML = html
                if (dom != undefined) {
                    $(dom).append(loading)
                    $(dom).css('position', 'relative')
                    $(dom).find('.loading').css('position', 'absolute')
                } else {
                    $('body').append(loading)
                }
            },
            Vue.prototype.hideLoading = function (dom) {
                if (dom != undefined) {
                    $(dom).find('.loading').remove()
                } else {
                    $('.loading').remove()
                }
            },
            Vue.prototype.getQuery = function (name, Url) {
                var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
                var url = Url || location.href;
                if (reg.test(url)) {
                    return unescape(RegExp.$2.replace(/\+/g, ''))
                }
                return '';
            },
            Vue.prototype.listAnim = function (type) {
                if (type == 1) {
                    $('.animlist').removeClass('anim');
                    $('.animlist td').css('opacity', 0)
                } else {
                    $('.animlist td').css('opacity', 1)
                    setTimeout(function () {
                        $('.animlist').addClass('anim');
                    }, 200)
                }
            },
            Vue.prototype.formatDate = function (date) {
                var time_str = date;
                if (time_str) {
                	var t = time_str.substr(0, 10);
                	return t;
                }
                return null;
            },
            Vue.prototype.formatTime = function (date) {
                var time_str = date;
                if (time_str) {
                	var t = time_str.substr(11, 19);
                	return t;
                }
                return null;
            },
            Vue.prototype.formatYMD = function (data) {
            	if (data) {
            		var da = new Date(data);
            		var year = da.getFullYear() + '年';
            		var month = da.getMonth() + 1 + '月';
            		var date = da.getDate() + '日';
            		var ymd = [year, month, date].join('');
            		return ymd;
            	} else{
            		return null;
            	}
            },
            Vue.prototype.timestampToTime = function (timestamp) {
                var tt = timestamp;
                if (tt) {
                	var Y = tt.substr(8, 2)+ ':';
                	var M = tt.substr(10, 2);
                	var D = tt.substr(12, 2);
                	return Y + M + D;
                }
                return null;
            },
             Vue.prototype.formatymd = function (value) {
            	if (value) {
            		var y = value.substr(0, 4);
                	var m = value.substr(4, 2);
                	var d = value.substr(6);
            		return [y,m,d].join('-');
            	} else{
            		return null;
            	}
            },
            Vue.prototype.timestampToTime =function (timestamp) {
                timestamp=Number(timestamp);
                var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = (date.getDate()>9?date.getDate():'0'+date.getDate()) + ' ';
                var h = (date.getHours()>9?date.getHours():'0'+date.getHours()) + ':';
                var m = (date.getMinutes()>9?date.getMinutes():'0'+date.getMinutes()) + ':';
                var s = date.getSeconds()>9?date.getSeconds():'0'+date.getSeconds();
                return Y+M+D+h+m+s;
            },
            Vue.prototype.getUrlParamsByKey = function (string, key) {
                if (string.indexOf("?") != -1) {
                    var string = string.substr(string.indexOf("?") + 1);
                    var strs = string.split("&");
                    for (var i = 0; i < strs.length; i++) {
                        var tempArr = strs[i].split("=");
                        if (key == tempArr[0]) {
                            return decodeURI(tempArr[1]);
                        }
                    }
                }
                return null;
            },
            Vue.prototype.formatUnit=function(value){
            	let r= /^(\-|\+)?\d+(\.\d+)?$/;
            	if(value==0){
            		return 0;
            	}else  if (value > 0 && value<10000) {
            		let  yu= value/1;
			            if(r.test(value)){
					        return (parseInt(value)!=value)? (yu.toFixed(0)) : yu;
					    }
			     }else  if (value >=10000 && value < 100000000) {
			          let  tow= value / 10000;
			            if(r.test(value)){
					        return (value%10000)!=0? (tow.toFixed(2) + '万') : (tow+'.00万');
					    }
			     } else if (value >= 100000000) {
			           let  toy = value / 100000000;
			            if(r.test(value)){
					        return (value%100000000)!=0 ? (toy.toFixed(2) + '亿') : (toy+'.00亿');
					    }
			     }
			     return null;
           },
           Vue.prototype.cookies=function(){
           	 let _cookie = {}
		    _cookie.write = function (key, value, duration) {
		        let d = new Date();
		        d.setTime(d.getTime() + 1000 * 60 * 60 * 24 * duration);
		        document.cookie = key + "=" + encodeURI(value) + "; expires=" + d.toGMTString()+";domain="+domainUrl+";path=/;";
		    };
		    _cookie.read = function (key) {
		        let arr = document.cookie.match(new RegExp("(^| )" + key + "=([^;]*)(;|$)"));
		        if (arr != null)
		            return decodeURIComponent(arr[2]);
		        return "";
		    };
		    _cookie.del=function(key){
		    	let d = new Date(),delValue;
		        d.setTime(d.getTime() -1);
		        delValue=this.read(key);
		        if (!!delValue) {
		            document.cookie = key+'='+delValue+';expires='+d.toGMTString()+";domain="+domainUrl+";path=/;";
		        }
		    };
		    return _cookie;

           },
           Vue.prototype.aboutUsSideBar=function(){
                $('div.left-side ul li').click(function(){
                    $('div.left-side ul li').removeClass("arrow-active");
                    $(this).addClass("arrow-active");
                });
           },
           Vue.prototype.calcTime=function(t){
				var str = '';
				if (t) {
					var arr=t.split(' ');
					var arr1=arr[0].split('-');
					var arr2=arr[1].split(':');
					var t1 = Date.parse(new Date(arr1[0],(arr1[1]-1),arr1[2],arr2[0],arr2[1],arr2[2]));

					var t2 = Date.parse(new Date());
					var s = (t2 - t1);
					if (s < (86400000 * 2)) {
						var day = Math.floor(s / 86400000);
						var hour = Math.floor((s % 86400000) / 3600000);
						var minute = Math.floor((s % 86400000 % 3600000) / 60000);
						var seconds = Math.floor(s % 86400000 % 3600000 % 60000) / 1000;
						if (day > 0) {
							str = day + "天前";
							return str;
						}
						if (hour > 0) {
							str = hour + "小时前";
							return str;
						}
						if (minute > 0) {
							str = minute + "分钟前";
							return str;
						}
					} else {
						return this.formatYMD(t1);
					}
				} else {
					return str;
				}
    }
}
}



// WEBPACK FOOTER //
// ./src/js/util.js